module.exports = __webpack_public_path__ + "static/media/22.a81889b1.jpeg";